import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/ManagementWork.css';

const ManagementWork = () => {
  return (
    <>
      <Helmet>
        <title>Management & Work - Leadership & Workplace Innovation | Redbox Global</title>
        <meta name="description" content="Expert insights on hybrid work strategies, leadership skills, employee retention, AI-powered productivity tools, workplace innovation, and the future of work." />
        <meta name="keywords" content="management, leadership, workplace innovation, hybrid work, employee retention, productivity tools, future of work, HR strategy, business leadership, workplace trends" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/management-work" />
        <meta property="og:title" content="Management & Work - Leadership & Workplace Innovation | Redbox Global" />
        <meta property="og:description" content="Expert insights on hybrid work strategies, leadership skills, employee retention, and workplace innovation." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/management-work" />
        <meta name="twitter:title" content="Management & Work - Leadership & Workplace Innovation | Redbox Global" />
        <meta name="twitter:description" content="Expert insights on hybrid work strategies, leadership skills, employee retention, and workplace innovation." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/management-work" />
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Management & Work</h1>
        <p className="page-subtitle">Leadership strategies, workplace innovation, and the future of work</p>
      </div>
      
      <div className="page-content">
        <a href="/article/hybrid-work-best-practices" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&h=600&fit=crop" alt="Modern workplace" />
            </div>
            <div className="featured-content">
              
              <h2>Mastering the Hybrid Work Revolution</h2>
              <p>Leading organizations share their strategies for creating productive, engaged teams in the new era of flexible work arrangements, balancing remote and in-office collaboration.</p>
              <span className="article-meta">This Week's Feature</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/leadership-skills-2026" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=400&fit=crop" alt="Leadership" />
              </div>
              <div className="article-content">
               
                <h2>Essential Leadership Skills for 2026</h2>
                <p>What top executives say are the must-have competencies for leading in today's complex business environment.</p>
                <span className="article-meta">February 3, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/employee-retention-strategies" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600&h=400&fit=crop" alt="Team collaboration" />
              </div>
              <div className="article-content">
               
                <h2>Winning the War for Talent Retention</h2>
                <p>Innovative approaches companies are using to keep their best employees engaged and committed.</p>
                <span className="article-meta">February 2, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/productivity-tools-innovation" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop" alt="Productivity tools" />
              </div>
              <div className="article-content">
               
                <h2>AI-Powered Productivity Tools Transforming Work</h2>
                <p>How artificial intelligence is revolutionizing workplace efficiency and employee performance.</p>
                <span className="article-meta">February 1, 2026</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default ManagementWork;
